<script src="../service-box-container/service-box-container.component.ts"></script>

<ng-template #skeleton>
  <app-weather-card-skeleton></app-weather-card-skeleton>
</ng-template>

<div class="app-card-box w-100 p-md"
     [ngClass]="wClass"
     (click)="onOpenDetail()"
     *ngIf="loaded; else skeleton"
     style="position: relative;">

  <div class="weather-card__blob-1"></div>
  <div class="weather-card__blob-2"></div>

  <div class="d-flex w-100 gap-3">

    <div class="w-100">

      <div class="d-flex ion-justify-content-between">

        <div class="live-badge">
          <div class="live-dot"></div>
          <div class="live-text ts-caption text-font-color">Live</div>
        </div>

        <div>
          <div class="ts-caption-bold text-font-color ion-text-uppercase">{{ 'Qualità aria' | translate }}</div>
          <div [ngClass]="airQualityLabel"
               class="ts-caption-bold air-quality-value mt-xs">{{ ('WEATHER_VALUE.' + airQualityLabel) | translate }}
          </div>

        </div>

      </div>

      <div class="d-flex justify-content-center ion-align-items-center ion-justify-content-between">

        <div class="d-flex ion-align-items-center gap-2">
          <app-weather-icon size="small"
                            [class]="'text-azzurro-200'"
                            [params]="params"></app-weather-icon>
          <div>
            <div class="ts-body-bold text-font-color">
              {{ label }}
            </div>
            <div class="d-flex gap-3">

              <div class="ts-h3 text-font-color">
                {{ currentWeather.temperature | number: '1.0-0' }}
                <span class="degree-symbol">&deg;C</span>
              </div>

              <div class="d-flex gap-1 text-font-color" *ngIf="currentWeather.precipitation > 0">
                <div class="material-symbols-outlined">rainy</div>
                <div
                  class="ts-caption line-height-normal text-font-color">{{ currentWeather.precipitation > 0 ? (currentWeather.precipitation | number: '1.0-0') + '%' : ('Assenti' | translate) }}
                </div>
              </div>


            </div>

          </div>

        </div>

      </div>
    </div>

  </div>


</div>
